<template>
  <div class="container-fluid p-0">
    <div class="sidebar">
      <sidebar-menu
        v-if="
          $store.getters['account/accountData'].role === 'Transportation' ||
            $store.getters['account/accountData'].role === 'Driver'
        "
        :menu="menuTransportation"
        :collapsed="true"
        @toggle-collapse="onToggleCollapse"
      >
      </sidebar-menu>
      <sidebar-menu v-else :menu="menu" :collapsed="true" @toggle-collapse="onToggleCollapse">
        {{ $t('menu') }}
      </sidebar-menu>
      <!-- <NavigationBar /> -->
    </div>
    <div :class="fullSideBar === false ? 'header-content' : 'header-sidebar'">
      <Header />
      <div
        v-if="$route.name == 'Dashboard'"
        class="align-content-center m-auto justify-content-center"
      >
        <b-carousel fade indicators>
          <b-carousel-slide caption="ssss"></b-carousel-slide>
          <b-carousel-slide caption="ssss"></b-carousel-slide>
          <b-carousel-slide caption="ssss"></b-carousel-slide>
        </b-carousel>
      </div>
    </div>
    <div :class="fullSideBar === false ? 'main-content' : 'main-sidebar'">
      <Content />
    </div>
    <notifications />
  </div>
</template>

<script>
// import NavigationBar from '@/components/NavigationBar'
import Header from './Header';
import Content from './Content';

const logoImg = {
  data() {
    return {
      src: 'img/xtendlogo.png',
    };
  },
  template:
    '<div v-if="$store.state.sidebarShow === false" class="pt-3 pl-2 pb-3 mb-3 text-white"><img :src="src" width="70"> My Xtend ERP</div><div v-else class="pt-3 pl-2 pb-3 mb-3 text-white"><img :src="src" width="30"></div>',
};

export default {
  name: 'dashboard',
  components: {
    // NavigationBar,
    // asdf
    Content,
    Header,
  },
  data() {
    return {
      fullSideBar: true,
      menuTransportation: [
        {
          header: true,
          title: 'Main Navigation',
          component: logoImg,
          hiddenOnCollapse: false,
        },
        {
          href: '/vehicle',
          title: 'Vehicle',
          icon: 'icon-vehicle',
        },
        {
          title: 'Report',
          icon: 'icon-report',
          child: [
            {
              href: '/reports/vehicle',
              title: 'Vehicle',
              icon: 'fas fa-shipping-fast',
            },
          ],
        },
        {
          title: 'Settings',
          icon: 'fas fa-cogs',
          child: [
            {
              href: '/settings/vehicle-category',
              title: 'Vehicle Category',
              icon: 'icon-vehicle-type',
            },
          ],
          class: this.$store.getters['account/accountData'].role === 'Manager' ? 'hide-on' : '',
        },
      ],
      menu: [
        {
          header: true,
          title: 'Main Navigation',
          component: logoImg,
          hiddenOnCollapse: false,
        },
        {
          href: '/dashboard',
          title: this.$root.$t('dashboard'),
          icon: 'fas fa-chart-pie',
        },
        {
          href: '/attendance',
          title: this.$root.$t('attendance'),
          icon: 'fas fa-user-clock',
        },

        {
          href: '/leave',
          title: this.$root.$t('leave'),
          icon: 'fas fa-chalkboard-teacher',
        },
        {
          href: '/overtime',
          title: this.$root.$t('overtime'),
          icon: 'fas fa-calendar-alt',
        },
        {
          href: '/new-reimbursement',
          title: this.$root.$t('reimbursement'),
          icon: 'fas fa-hand-holding-usd',
          class: this.$store.getters['account/accountData'].role === 'Manager' ? 'hide-on' : '',
        },
        {
          href: '/letter',
          title: this.$root.$t('letter'),
          icon: 'fa fa-envelope',
        },
        {
          href: '/lokasi-pegawai',
          title: 'Lokasi Pegawai',
          icon: 'fas fa-map-marker-alt'
        },
        {
          title: this.$root.$t('settings'),
          icon: 'fas fa-cogs',
          child: [
            {
              title: 'Instansi',
              icon: 'fas fa-user',
              child: [
                {
                  href: '/company-structure/company',
                  title: this.$root.$t('company'),
                  icon: 'fas fa-building',
                },
                {
                  href: '/company-structure/branch',
                  title: this.$root.$t('branch'),
                  icon: 'fas fa-code-branch',
                },
                {
                  href: '/company-structure/department',
                  title: this.$root.$t('department'),
                  icon: 'fas fa-network-wired',
                },
                {
                  href: '/company-structure/employee',
                  title: this.$root.$t('employee'),
                  icon: 'fas fa-user-tie',
                },
              ],
            },
            {
              href: '/settings/access',
              title: this.$root.$t('access'),
              icon: 'fas fa-key',
            },
            {
              href: '/settings/attendance-setting',
              title: this.$root.$t('setAttendance'),
              icon: 'fas fa-user-clock',
            },
            {
              href: '/settings/leave-type',
              title: this.$root.$t('leaveType'),
              icon: 'icon-leave-type',
            },

            // {
            //   href: '/settings/photo-category',
            //   title: this.$root.$t('photoCate'),
            //   icon: 'fas fa-images',
            // },

            // {
            //   href: '/settings/reimbursement-type',
            //   title: this.$root.$t('reimbursementType'),
            //   icon: 'icon-reimbursement-type',
            // },
          ],
          class: this.$store.getters['account/accountData'].role === 'Manager' ? 'hide-on' : '',
        },
        // {
        //   href: '/documents',
        //   title: this.$root.$t('document'),
        //   icon: 'icon-document',
        // },
      ],
    };
  },
  mounted: function() {},
  methods: {
    onToggleCollapse(collapsed) {
      this.fullSideBar = collapsed;
      this.$store.commit('toggleSidebarDesktop', collapsed);
    },
  },
};

/**
 *  {
          class: ' p-0 mt-2',
          title: 'Sales',
          icon: 'icon-sales',
          child: [
            {
              href: '/sales/quotation',
              title: 'Quotation',
              icon: 'fas fa-file-signature',
            },
            {
              href: '/sales/invoice',
              title: 'Invoice',
              icon: 'fas fa-file-invoice-dollar',
            },
            {
              href: '/sales/delivery-order',
              title: 'Delivery Order',
              icon: 'fas fa-truck',
            },

            // {
            //   href: '/sales/sales-order',
            //   title: 'Sales Order',
            //   icon: 'fas fa-hand-holding-usd'
            // },
          ],
        },

            {
          title: 'Inventory',
          icon: 'icon-inventory',
          child: [
            {
              href: '/inventory/purchase',
              title: 'Purchase',
              icon: 'fas fa-clipboard-check',
            },
            {
              href: '/inventory/stock-in',
              title: 'Stock In',
              icon: 'fas fa-dolly-flatbed',
            },
            {
              href: '/inventory/stock-out',
              title: 'Stock Out',
              icon: 'fas fa-pallet',
            },
            {
              href: '/inventory/stock-item-list',
              title: 'Stock Item List',
              icon: 'fa fa-sitemap',
            },
          ],
        },

          {
          title: 'Report',
          icon: 'icon-report',
          child: [
            {
              href: '/reports/vehicle',
              title: 'Vehicle',
              icon: 'fas fa-shipping-fast',
            },
            {
              href: '/reports/weekly-my-job',
              title: 'Weekly My Job',
              icon: 'fas fa-calendar-alt',
            },
          ],
        },

            {
          title: 'Accounting',
          icon: 'icon-financial-journal',
          child: [
            {
              href: '/accounting/account-list',
              title: 'Account',
              icon: 'fas fa-money-check-alt',
            },
           
            {
              href: '/accounting/cash-in',
              title: 'Cash In',
              icon: 'fa fa-chevron-circle-down',
            },
            {
               href: '/accounting/cash-out',
               title: 'Cash Out',
               icon: 'fa fa-chevron-circle-up'
            },
            {
               href: '/accounting/cash-transfer',
               title: 'Cash Transfer',
               icon: 'fas fa-share'
            },
            {
              href: '/accounting/initial-account-balance',
              title: 'Initial Account Balance',
              icon: 'fa fa-balance-scale'
            },
            {
              href: '/accounting/journal',
              title: 'Journal',
              icon: 'fa fa-book',
            },
            {
              href: '/accounting/ledger',
              title: 'Ledger',
              icon: 'fas fa-journal-whills',
            },
                        {
              href: '/my-job',
              title: 'My Job',
              icon: 'fas fa-list-alt',
            },
            {
              href: '/worksheet',
              title: 'Worksheet',
              icon: 'fas fa-tasks',
            },
          ],
        },

           {
          title: 'Master Data',
          icon: 'icon-master-data',
          child: [
            {
              href: '/company-structure/customer',
              title: 'Customer',
              icon: 'fas fa-hands',
            },
            {
              href: '/company-structure/supplier',
              title: 'Supplier',
              icon: 'fas fa-city',
            },
            {
              href: '/sales/items',
              title: 'Items',
              icon: 'fas fa-cubes',
            },
            
        },

         {
          title: 'Purchase',
          icon: 'icon-purchase-requisition',
          child: [
            {
              href: '/purchase-requisition',
              title: 'Purchase Requisition',
              icon: 'fas fa-clipboard-check',
            },
          ],
        },

        {
          title: 'Assets',
          icon: 'icon-asset',
          child: [
            {
              href: '/vehicle',
              title: 'Vehicle',
              icon: 'fas fa-car',
            },
          ],
        },

        {
              href: '/reimbursement',
              title: 'Reimbursement',
              icon: 'fas fa-hand-holding-usd',
              class: this.$store.getters['account/accountData'].role === 'Manager' ? 'hide-on' : '',
            },

             {
          title: 'HRD',
          icon: 'icon-hrd',
          child: [

          ],
        },

          // {
            //   href: '/settings/stock-area',
            //   title: 'Stock Area',
            //   icon: 'fas fa-warehouse',
            // },
            // {
            //   href: '/settings/vehicle-category',
            //   title: 'Vehicle Category',
            //   icon: 'icon-vehicle-type',
            // },
            // {
            //   href: '/settings/worksheet-type',
            //   title: 'Worksheet Type',
            //   icon: 'fas fa-object-ungroup',
            // },
            // {
            //   href: '/settings/vehicle',
            //   title: 'Vehicle',
            //   icon: 'fas fa-car',
            // },

                        // {
            //   href: '/settings/overtime-type',
            //   title: 'Overtime Type',
            //   icon: 'fas fa-user-clock',
            // },

                        // {
            //   href: '/settings/qrcode',
            //   title: 'QR Code',
            //   icon: 'fas fa-qrcode',
            // },
    
 * 
 */
</script>

<style>
.header-bottom-homepage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 85%;
  z-index: -1;
}

.fa-chart-pie {
  font-size: 18px;
  image-rendering: pixelated;
}

.icon-overtime {
  background-image: url('/img/general/Group 105hdpi.png');
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-leave {
  background-image: url('/img/general/Leavehdpi.png');
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.btn-op {
  padding: 0.5rem 0.5rem;
  line-height: 1.5;
}

.icon-edit {
  background-color: transparent !important;
  border-color: transparent !important;
  background-image: url('/img/general/Edithdpi.png');
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-info {
  background-color: transparent !important;
  border-color: transparent !important;
  background-image: url('/img/general/Detailshdpi.png');
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-delete {
  background-color: transparent !important;
  border-color: transparent !important;
  background-image: url('/img/general/Deletehdpi.png');
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-leave-type {
  height: 30px;
  width: 30px;
  margin-left: -7px;
  margin-right: 0px !important;
  background-image: url('/img/general/Leave Categoryhdpi.png');
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-reimbursement-type {
  height: 30px;
  width: 30px;
  margin-left: -7px;
  margin-right: 0px !important;
  background-image: url('/img/general/Reimburse Categoryhdpi.png');
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-overtime-type {
  height: 30px;
  width: 30px;
  margin-left: -7px;
  margin-right: 0px !important;
  background-image: url('/img/general/Overtime Categoryhdpi.png');
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-vehicle-type {
  height: 30px;
  width: 30px;
  margin-left: -7px;
  margin-right: 0px !important;
  background-image: url('/img/general/Vehicle Categoryhdpi.png');
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-reimbusement {
  background-image: url('/img/general/Reimburesehdpi.png');
  background-size: 22px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-timesheet {
  background-image: url('/img/general/Timesheethdpi.png');
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-report {
  background-image: url('/img/general/Report copy.svg');
  background-size: 36px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-vehicle {
  background-image: url('/img/general/Vehiclehdpi.png');
  background-size: 18px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-purchase-requisition {
  background-image: url('/img/general/Purchase Requisition copy.svg');
  background-size: 28px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-financial-journal {
  background-image: url('/img/general/Financial Journal.svg');
  background-size: 32px;
  background-position: center;
  background-repeat: no-repeat;
  image-rendering: auto;
  /* image-rendering: pixelated; */
}

.icon-hrd {
  background-image: url('/img/general/HRD copy.svg');
  background-size: 28px;
  background-position: center;
  background-repeat: no-repeat;
  /* image-rendering: pixelated; */
}

.icon-sales {
  background-image: url('/img/general/Sales.svg');
  background-size: 30px;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: 9px !important;
  /* align-items: center; */
  margin-top: -12px;
  margin-bottom: 0;
  padding: 0;
  /* image-rendering: pixelated; */
}

.icon-asset {
  background-image: url('/img/general/Asset copy.svg');
  background-size: 24px;
  background-position: center;
  background-repeat: no-repeat;
  /* image-rendering: pixelated; */
  filter: contrast(1000);
}
.icon-master-data {
  background-image: url('/img/general/Master data copy (1).svg');
  background-size: 36px;
  background-position: center;
  background-repeat: no-repeat;
  /* image-rendering: pixelated; */
  filter: contrast(1000);
}

.icon-document {
  background-image: url('/img/general/My Job copy.svg');
  background-size: 36px;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-inventory {
  background-image: url('/img/general/Inventory.svg');
  background-size: 36px;
  background-position: center;
  background-repeat: no-repeat;
  filter: contrast(1000);
}
</style>
